import { render, staticRenderFns } from "./BooleanField.vue?vue&type=template&id=6bc74356"
import script from "./BooleanField.vue?vue&type=script&lang=js"
export * from "./BooleanField.vue?vue&type=script&lang=js"
import style0 from "./BooleanField.vue?vue&type=style&index=0&id=6bc74356&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports